<template>
  <v-container>
      <v-row class="mb-4" justify="space-between" align="center" style="margin-top:10px ">
      <v-col cols="4">
        <img
          v-if="logoSrc"
          :src="logoSrc"
          alt="logo"
          style="max-height: 80px; max-width: 100%;"
        />
      </v-col>
      <v-col cols="4" class="text-center">
        <h2>{{ $t('DESIRE_FORM') }}</h2>
      </v-col>


    </v-row>
    <v-row>
  <v-col cols="12" class="text-left">
    <small><strong>{{ $t('PRINT_DATE') }} {{ currentDateTime }}</strong> </small>
  </v-col>
</v-row>


    <div class="mb-4" dir="rtl" style="margin-bottom: 10px">
      <p style="margin-bottom: 2px;"><strong>{{$t('STUDENT_NAME')}}:</strong> {{ this.serverTranslate(studentName) }}</p>
      <p><strong>{{$t('NID')}}:</strong> {{ cardId }}</p>
    </div>
    <v-data-table
        :dir="textDirection"
      :headers="headers"
      :items="orderedApplications"
      class="elevation-1"
      dense
      item-value="appNum"
       :hide-default-footer="true"
    >
      <template v-slot:item.index="{ index }">
        {{ index + 1 }}
      </template>

      <template v-slot:item.facultyName="{ item }">
        {{ $t(serverTranslate(item.facultyName)) }}
      </template>

      <template v-slot:item.appNum="{ item }">
        {{ item.appNum }}
      </template>

      <template v-slot:item.desireNumber="{ item }">
        {{ item.desireNumber }}
      </template>
       <template v-slot:item.certificateType="{ item }">
        {{ $t(serverTranslate(item.certificateType)) }}
      </template>
         <template v-slot:item.certificateSpecialization="{ item }">
        {{ $t(serverTranslate(item.certificateSpecialization)) }}
      </template>


    </v-data-table>
       <v-row class="mt-8" style="margin-top: 10px">
      <v-col cols="12" class="text-right">
        <p><strong>{{$t('SIGNATURE')}}:</strong>{{ serverTranslate(studentName) }} </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import serverTranslationsMixin from "@/mixins/serverTranslations";

export default {
      mixins: [serverTranslationsMixin],
  name: 'PrintDataTable',
  props: {
    orderedApplications: {
      type: Array,
      required: true,
    },
        studentName: {
      type: String,
      required: true,
    },
    cardId: {
      type: String,
      required: true,
    },
    logoSrc:{
       type: String,
    }
    },


  computed: {
    textDirection() {
    return this.$store.state.direction ? 'rtl' : 'ltr';
    },

    headers() {
      return [
        { text: '#', value: 'index' },
        { text: this.$t('FACULTY'), value: 'facultyName' },
        { text: this.$t('ADMISSION_DATA.APPID'), value: 'appNum' },
        { text: this.$t('DESIRE_NUMBER'), value: 'desireNumber' },
        { text: this.$t('ADMISSION_DATA.STEP2.CERTIFICATE_NAME'), value: 'certificateType' },
        { text: this.$t('ADMISSION_DATA.STEP2.MAJOR'), value: 'certificateSpecialization' },

      ];
    },
        currentDateTime() {
      const now = new Date();
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      };
      return now.toLocaleString('ar-EG', options); // ✅ جديد: التاريخ بصيغة عربية
    },
  },

};
</script>